import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import BtnWhite from '../../../../../Shared/Buttons/BtnWhite';
import ButtonDownload from '../../Buttons/ButtonDownload/ButtonDownload';

const subscriptionBasic = (props) => {
  return (
    <div className='subscriptionBasic'>
      <p className='title'>
        מנוי {props.selectedSubscriber.cli} הינו מנוי לשירות המתנה נעימה בסיסי שבמסגרתו הורדת כל שיר הינה {props.aocDetails.itemPrice}₪{' '}
      </p>
      <p className='subtitle'>האם אתה מעוניין לשדרג לשרות ללא הגבלה?</p>
      <div className='boxes'>
        <div className='box-download'>
          <div className='box-title'>שירות המתנה נעימה בסיסי</div>
          <div className='box-text'>הורדת שיר זה הינה בעלות חד פעמית בסך</div>
          <div className='price'>{props.aocDetails.itemPrice}₪</div>
          <BtnWhite text='הורד' onclick={() => props.downloadSong()} />
        </div>
        <div className='box-upgrade'>
          <div className='box-title'>שדרג להמתנה נעימה ללא הגבלה</div>
          <div className='box-text'>הורדת שירין ללא הגבלה וללא עלות נוספת. השרות כרוך בתשלום חודשי קבוע ומתמשך בסך</div>
          <div className='price'>{props.aocDetails.premiumPackagePrice}₪</div>
          <div className='btn-white-container'>
            <ButtonDownload
              text='שדרג והורדה'
              onclick={() => props.upgradeToUnlimited()}
              icon={<Image src={require('../images/downloadIcon_pink.svg')} alt='להורדה' />}
            />
          </div>
        </div>
      </div>
      <p className='charge'>החיוב יבוצע דרך מנוי {props.selectedSubscriber.cli}</p>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    selectedSubscriber: state.fundialPage.selectedSubscriber,
    aocDetails: state.fundialPage.aocDetails,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(subscriptionBasic);
